import { adaptiveUiMixin } from './adaptiveui-mixin';
import { connect } from 'pwa-helpers/connect-mixin';
import { GetSection } from '../parsers/commands/get-section';
import { Logger } from '../logger';
import { appStore } from '../../slice/appSlice';

export const VIEW_MODE_MAIN = 'main';
export const VIEW_MODE_DIALOG = 'dialog';

export const TemplateMixin = (BaseClass: any) => class extends adaptiveUiMixin(connect(appStore)(BaseClass)) {
    dialogsStack: any[] = [];
    
    // Remove @property decorators and define as regular properties
    dialogService: string = '';
    dialogParams: Record<string, any> = {};

    // Add static properties definition for Lit elements
     static get properties() {
        // Get the parent class properties first
        const parentProperties = super.properties || {};
        
        // Merge with our own properties
        return {
            ...parentProperties,
            dialogService: { type: String },
            dialogParams: { type: Object }
        };
    }

    onEscapeKeyDownInSectionPageHandler(evt: KeyboardEvent) {
        let isEscape = false;
        if ('key' in evt) {
            isEscape = (evt.key === 'Escape' || evt.key === 'Esc');
        } else {
            isEscape = (evt as any).keyCode === 27;
        }
        if (isEscape) {
            this.hideSectionPage();
        }
    }
    
    hideSectionPage() {
        this.view = "main";
        this.requestUpdate()
        // appStore.dispatch(setView(VIEW_MODE_MAIN));
    }

    updateLocationHash() {
        const hashes = window.location.hash.split('/');
        const page = hashes[1] || '0';
        const tab = hashes[2] || '0';

        // remove frontend route
        let pagePath;
        const paths = window.location.pathname.split('/');
        if (paths.length === 4) {
            pagePath = `/${paths[1]}/`;
        } else {
            pagePath = window.location.pathname;
        }

        // Use string concatenation instead of replaceState with null
        const newUrl = `${pagePath}${window.location.search}#/${page}/${tab}`;
        window.history.replaceState(null, '', newUrl);
    }

    /**
     * Parse request GET params returned into params for template
     * @return {{}}
     */
    parseParams(): { [key: string]: any } {
        const au = document.querySelector('adaptive-ui');
        if (!au) {
            return {};
        }
        const p = au.getAttribute('params');
        return p ? JSON.parse(p) : {};
    }

    /**
     * Logout the current session
     * performs logout cleanup like clearing the local storage
     *
     * @param {Event} evt
     */


  

    /**
     * Returns the media formatted logo url or an Initials' Avatar if the logo is missing
     * @param {Object} gateway
     * @return logo url
     */
    _computeLogo(gateway: { name: string; iconImage: string | null; logo: string | null; }) {
        // rounded=true
        let defaultUrl = 'https://ui-avatars.com/api/?background=FFFFFF&name=' + encodeURIComponent(gateway.name);
        if (gateway.iconImage) {
            defaultUrl = `/media/${gateway.iconImage}`;
        }
        if (gateway.logo) {
            defaultUrl = `/media/${gateway.logo}`;
        }
        if (gateway.logo == null || gateway.iconImage == null) {
            defaultUrl = `https://www.interintel.co.ke/media/upc_institution_logo/Interintel_Logo_1.png`;
        }
        
        return defaultUrl;
    }

    async _activateLoadSectionInterface(...args: any[]): Promise<any> {
        console.log("args in template mixin ",args)
        const self = this;
        let dialog: any;
                
        if (self.view === VIEW_MODE_DIALOG) {
            dialog = this.qs('#dialog');
            if (dialog) {
                this.dialogsStack.push([dialog.payload, Object.assign({}, dialog.params)]);
            }

            // Store the service and params for the dialog
            if (args.length > 0) {
                this.dialogService = args[0]; // First arg is typically the service
                this.dialogParams = args[1] || {}; // Second arg is params
            }
            
            this.requestUpdate();
            
        } else {
            this.view = VIEW_MODE_DIALOG;
            
            // Store the service and params for the dialog
            if (args.length > 0) {
                this.dialogService = args[0]; // First arg is typically the service
                this.dialogParams = args[1] || {}; // Second arg is params
            }
            
            this.requestUpdate();
        }

        this.scrollToTop();
        await this.updateComplete;

        dialog = this.qs('#dialog');
        if (!dialog) {
            Logger.i.warn('[BAD INTERFACE] children must have section-dialog with #dialog');
            throw new DOMException('Dialog element not found');
        }

        // Pass the args to the dialog
        if (args[0] instanceof GetSection) {
            dialog.payload = args[0];
            dialog.loading = false;
        } else {
            // Use the stored service and params
            if (typeof (dialog as any).loadServiceParams === 'function') {
                (dialog as any).loadServiceParams(this.dialogService, this.dialogParams);
            } else if (typeof (dialog as any)._loadServiceParams === 'function') {
                (dialog as any)._loadServiceParams(this.dialogService, this.dialogParams);
            } else {
                console.warn('Dialog does not have loadServiceParams or _loadServiceParams method');
                // Fallback: set properties directly
                dialog.service = this.dialogService;
                dialog.params = this.dialogParams;
            }
        }

        // ✅ Explicit return
        return dialog;
    }

    // viewMain() {
    //     appStore.dispatch(setView(VIEW_MODE_MAIN));
    // }

    /**
     * Dialogs Back navigation, Pop dialogs' stack
     *
     */
    mainNavigation() {
        if (!this.dialogsStack.length) {
            this.viewMain();
            this.updateLocationHash();
            this.checkForDatalistReload();
            this.checkForPaymentMethodSummaryReload();
        } else {
            const args = this.dialogsStack.pop();
            const dialog = this.qs('#dialog');

            if (dialog && args) {
                dialog.payload = args[0];
                dialog.params = args[1];
                dialog.loading = false;
            }
        }
    }

    // checkForDatalistReload() {
    //     // Implementation remains the same
    //     let formRenders = document.querySelectorAll('form-render');
    //     formRenders.forEach((form) => {
    //         // ... existing implementation
    //     });
    // }

    // checkForPaymentMethodSummaryReload() {
    //     // Implementation remains the same
    //     let formRenders = document.querySelectorAll('form-render');
    //     formRenders.forEach((form) => {
    //         // ... existing implementation
    //     });
    // }

    _gridClasses(feed: { sectionSize: string; }) {
        let grids: string[];
        grids = feed.sectionSize.split('|');
        const gridValue = Math.floor(Number(grids[0]) / 2);
       
        if (!feed.sectionSize) {
            grids = '24|24|24'.split('|');
        } else {
            grids = feed.sectionSize.split('|');
        }
     
        try {
             // Map grid values to flexbox width classes
      const gridMapping: { [key: number]: string } = {
        1: 'w-full',                // Full width (100%)
        2: 'md:w-1/2',              // Half width on medium+ screens (50%)
        3: 'md:w-1/2',              // One third on medium+ screens (33.33%)
        4: 'md:w-1/2',              // One quarter on medium+ screens (25%)
        5: 'md:w-1/2',              // One fifth on medium+ screens (20%)
        6: 'md:w-1/2',              // One sixth on medium+ screens (16.66%)
        8: 'md:w-1/2',              // One eighth on medium+ screens (12.5%)
        12: 'w-full',               // Full width
      };

      // Default to full width if mapping doesn't exist
      return gridMapping[gridValue] || 'w-full';

        } catch (e) {
            console.error('Error parsing grid value:', e);
            return 'w-full';
        }
    }

    _computePage(getSection: { pageGroups: any[]; }) {
        const pageGroup = getSection.pageGroups[0];
        this.title = pageGroup.title;
        return pageGroup.getTab(0);
    }

    // To scroll to top of window
    // TODO make static
    scrollToTop() {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
};